import {
  ConfluenceIcon,
  GoogleDriveIcon,
  LinearIcon,
  SlackIcon,
  GlobeIcon,
  NotionIcon,
  GitHubIcon,
  JiraIcon,
  FileIcon,
  InlineCodeIcon,
  SharepointIcon,
  GitIcon,
  SliteLogoInCircleIcon,
  HubspotIcon,
  AttioIcon,
  AsanaIcon,
  IntercomIcon,
  GitLabIcon,
} from '@slite/icons'
import { SuperSource } from '@slite/search-client'
import { match } from 'ts-pattern'

const LEGACY_SOURCE_TYPES = [
  'GOOGLE_DRIVE',
  'SLACK_CHANNEL',
  'CONFLUENCE',
  'LINEAR',
  'WEBSITE',
  'NOTION',
  'FILES',
  'SHAREPOINT',
  'SLITE',
] as const
type LegacySourceType = (typeof LEGACY_SOURCE_TYPES)[number]
type SupportedSourceType = SuperSource | LegacySourceType

export function isSuperSourceIconShape(
  iconShape: string | null
): iconShape is string {
  return iconShape?.startsWith('#ext_') ?? false
}

export function isSupportedSourceType(
  stringSourceType: string
): stringSourceType is SupportedSourceType {
  if (LEGACY_SOURCE_TYPES.includes(stringSourceType as LegacySourceType)) {
    return true
  }
  if (Object.values(SuperSource).includes(stringSourceType as SuperSource)) {
    return true
  }
  return false
}

export const getSuperSourceIcon = ({
  iconShape,
}: {
  iconShape: string | null
}) => {
  if (!isSuperSourceIconShape(iconShape)) {
    return null
  }

  const sourceType = iconShape?.replace('#ext_', '')

  if (!isSupportedSourceType(sourceType)) {
    return null
  }

  const superSourceIcon = match(sourceType)
    .with(SuperSource.SLITE, () => SliteLogoInCircleIcon)
    .with('SLITE', () => SliteLogoInCircleIcon)
    .with(SuperSource.GOOGLE_DRIVE, () => GoogleDriveIcon)
    .with('GOOGLE_DRIVE', () => GoogleDriveIcon)
    .with(SuperSource.SLACK_CHANNEL, () => SlackIcon)
    .with('SLACK_CHANNEL', () => SlackIcon)
    .with(SuperSource.WEBSITE, () => GlobeIcon)
    .with('WEBSITE', () => GlobeIcon)
    .with(SuperSource.NOTION, () => NotionIcon)
    .with('NOTION', () => NotionIcon)
    .with(SuperSource.LINEAR, () => LinearIcon)
    .with('LINEAR', () => LinearIcon)
    .with(SuperSource.CONFLUENCE, () => ConfluenceIcon)
    .with('CONFLUENCE', () => ConfluenceIcon)
    .with(SuperSource.FILE, () => FileIcon)
    .with('FILES', () => FileIcon)
    .with(SuperSource.MICROSOFT_SHAREPOINT, () => SharepointIcon)
    .with('SHAREPOINT', () => SharepointIcon)
    .with(SuperSource.HUBSPOT, () => HubspotIcon)
    .with(SuperSource.ASANA, () => AsanaIcon)
    .with(SuperSource.ATTIO, () => AttioIcon)
    .with(SuperSource.INTERCOM, () => IntercomIcon)
    .with(SuperSource.GITHUB, () => GitHubIcon)
    .with(SuperSource.GITLAB, () => GitLabIcon)
    .with(SuperSource.GIT, () => GitIcon)
    .with(SuperSource.JIRA, () => JiraIcon)
    .with(SuperSource.CUSTOM, () => InlineCodeIcon)
    .exhaustive()

  return superSourceIcon
}
